// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1GJjv","col":"CardReaderDesc_col__2tlNy","label":"CardReaderDesc_label__1I6yZ"};